import { render, staticRenderFns } from "./MatchInvalidStep.vue?vue&type=template&id=f73fc96e"
import script from "./MatchInvalidStep.vue?vue&type=script&lang=js"
export * from "./MatchInvalidStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports